<template>
  <v-sheet>
      <v-row v-if="is_show_invites">
          <v-col>
              <v-card>
                  <v-card-title>
                      Приглашения
                      <v-spacer></v-spacer>
                      <v-btn
                          class="mx-2"
                          fab
                          dark
                          color="success"
                          @click="dialogInvite = true"
                      >
                          <v-icon dark>
                              mdi-plus
                          </v-icon>
                      </v-btn>
                  </v-card-title>
                  <v-card-text>
                      <work-space-invite-list ref="workSpaceInviteList" :workSpaceId="ID_WORK_SPACE"></work-space-invite-list>
                  </v-card-text>
              </v-card>
          </v-col>
      </v-row>
<!--      <v-row>-->
<!--          <v-col>-->
<!--              <v-card>-->
<!--                  <v-card-title>Пользователи</v-card-title>-->
<!--                  <v-card-text>-->
<!--                      <work-space-users :workSpaceId="ID_WORK_SPACE"></work-space-users>-->
<!--                  </v-card-text>-->
<!--              </v-card>-->
<!--          </v-col>-->
<!--      </v-row>-->
      <v-row>
          <v-col>
              <v-card>
                  <v-card-title>Пользователи</v-card-title>
                  <v-card-text>
                      <work-space-participants :workSpaceId="ID_WORK_SPACE"></work-space-participants>
                  </v-card-text>
              </v-card>
          </v-col>
      </v-row>
      <v-row>
          <v-dialog
              v-model="dialogInvite"
              width="800"
          >
              <v-card>
                  <v-card-title>
                      Пригласить пользователя <v-spacer></v-spacer>
                      <v-btn
                          icon
                          @click="dialogInvite = false"
                      >
                          <v-icon>mdi-close</v-icon>
                      </v-btn>
                  </v-card-title>
                  <v-card-text>
                      <work-space-invite-form @sent="onSentInvite"></work-space-invite-form>
                  </v-card-text>
              </v-card>
          </v-dialog>
      </v-row>
    </v-sheet>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
    opacity: 0;
}
</style>
<script>

// import WorkSpaceUsers from "../components/workspace/WorkSpaceUsers.vue";
import {mapActions, mapGetters} from 'vuex';
import WorkSpaceInviteForm from "../components/invite/WorkSpaceInviteForm.vue";
import WorkSpaceInviteList from "../components/workspace/WorkSpaceInviteList.vue";
import WorkSpaceParticipants from "../components/workspace/WorkSpaceParticipants.vue";
export default {
    name: 'WorkSpacePage',
    components: {
        WorkSpaceParticipants,
        WorkSpaceInviteList,
        WorkSpaceInviteForm,
        // WorkSpaceUsers
    },
    data() {
        return {
            dialogInvite: false
        }
    },
    methods: {
        ...mapActions('workspace', ['CHECKOUT']),
        onSentInvite(){
            this.dialogInvite = false;
            this.$refs.workSpaceInviteList.load();
        },
        onCreatedWorkSpace(data){
            this.CHECKOUT(data.id);
        }
    },
    computed:{
        ...mapGetters('workspace', ['ID_WORK_SPACE', 'IS_OWNER']),
        ...mapGetters('user', ['IS_ADMIN']),
        is_show_invites(){
            return this.IS_OWNER || this.IS_ADMIN;
        }
    }
}
</script>
